export { AuthFormHeader } from './AuthFormHeader';
export { StyledAuthHero, StyledAuthSubtitle, StyledAuthSwitch } from './auth-form-header.styled';
